'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ExternalArrow;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function ExternalArrow(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-external-arrow ' + className,
      viewBox: '0 0 16 16' },
    _react2.default.createElement(
      'defs',
      null,
      _react2.default.createElement('path', {
        id: 'new-tab-3-a',
        d: 'M8.92063492,2 L10.9269841,3.98119122 L6.14526984,8.68288401 C6.0487619,8.78018809 6,8.89655172 6,9.03398119 C6,9.17040752 6.0487619,9.28677116 6.14526984,9.3830721 L6.6247619,9.85554859 C6.72126984,9.95184953 6.84012698,10 6.97930159,10 C7.11746032,10 7.23631746,9.95184953 7.33384127,9.85554859 L12.0952381,5.13479624 L14,7.01567398 L14,2 L8.92063492,2 Z' })
    ),
    _react2.default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('polygon', {
        fill: 'currentColor',
        points: '11.46 8.5 11.46 12.46 3.54 12.46 3.54 4.54 7.5 4.54 7.5 3 2 3 2 14 13 14 13 8.5' }),
      _react2.default.createElement('use', { fill: 'currentColor', xlinkHref: '#new-tab-3-a' })
    )
  );
}

ExternalArrow.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/ExternalArrow/ExternalArrow.js
// module id = 1177
// module chunks = 1